import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { BadgeCheck, CircleX, RefreshCw, Trash2 } from "lucide-react";
import { API } from "@/lib/site";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CoverChargesPanel = ({ token }) => {
  const [charges, setCharges] = useState(null);
  const headers = { Authorization: `Bearer ${token}` };
  const load = useCallback(async () => {
    try { const response = await axios.get(`${API}/cover-charges`, { headers }); setCharges(response.data); } catch (error) { if (error.response?.status === 401) { localStorage.removeItem("soho_staff_token"); window.location.reload(); } }
  }, [token]);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (id, status) => {
    try { await axios.put(`${API}/cover-charges/${id}/status`, { status }, { headers }); load(); } catch {}
  };
  const removeCharge = async (id) => {
    if (!window.confirm(`Delete submission ${id}? This cannot be undone.`)) return;
    try { await axios.delete(`${API}/cover-charges/${id}`, { headers }); load(); } catch {}
  };
  return (
    <div className="covers" data-testid="covers-section">
      <div className="insights-head">
        <p className="kicker">Gate passes to verify</p>
        <button className="text-button insight-refresh" onClick={load} data-testid="refresh-covers-button"><RefreshCw size={12}/> Refresh</button>
      </div>
      {!charges || charges.length === 0 ? <p className="muted">No cover-charge submissions yet.</p> : charges.map((c) => (
        <div className="cover-row" key={c.id} data-testid={`cover-row-${c.id}`}>
          {c.payment_proof ? (
            <a className="proof-link" href={`${BACKEND_URL}/api/files/${c.payment_proof}`} target="_blank" rel="noreferrer" data-testid={`cover-proof-${c.id}`}><img src={`${BACKEND_URL}/api/files/${c.payment_proof}`} alt={`Payment proof from ${c.name}`}/></a>
          ) : <div className="proof-missing">No proof</div>}
          <div className="cover-main">
            <strong>{c.name}<span className="cover-ref">{c.id}</span></strong>
            <span>{c.event}{c.entry_type ? ` · ${c.entry_type}` : ""}{c.quantity > 1 ? ` × ${c.quantity}` : ""} · ₹{c.amount} · {c.phone}{c.email ? ` · ${c.email}` : ""}</span>
            <span className="cover-utr">UTR: {c.utr}</span>
          </div>
          <span className={`cover-status s-${c.status || "pending_verification"}`} data-testid={`cover-status-${c.id}`}>{(c.status === "verified" ? "Verified" : c.status === "rejected" ? "Rejected" : "Pending")}</span>
          <div className="cover-actions">
            <button onClick={() => setStatus(c.id, "verified")} data-testid={`verify-cover-${c.id}`}><BadgeCheck size={14}/> Verify</button>
            <button className="reject" onClick={() => setStatus(c.id, "rejected")} data-testid={`reject-cover-${c.id}`}><CircleX size={14}/> Reject</button>
            <button className="reject" onClick={() => removeCharge(c.id)} data-testid={`delete-cover-${c.id}`}><Trash2 size={14}/> Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};
